export interface IBrandPurchaserLink {
  id: number;
  email: string | null;
  isActive: boolean;
  createdAt: string | null;
  createdBy: number | null;
  updatedAt: string | null;
  updatedBy: number | null;
  deletedAt: string | null;
  deletedBy: number | null;
}

export class BrandPurchaserLink implements IBrandPurchaserLink {
  private readonly _id: number;
  private readonly _email: string | null;
  private readonly _isActive: boolean;
  private readonly _createdAt: string | null;
  private readonly _createdBy: number | null;
  private readonly _updatedAt: string | null;
  private readonly _updatedBy: number | null;
  private readonly _deletedAt: string | null;
  private readonly _deletedBy: number | null;

  constructor(props: IBrandPurchaserLink) {
    this._id = props.id;
    this._email = props.email;
    this._isActive = props.isActive;
    this._createdAt = props.createdAt;
    this._createdBy = props.createdBy;
    this._updatedAt = props.updatedAt;
    this._updatedBy = props.updatedBy;
    this._deletedAt = props.deletedAt;
    this._deletedBy = props.deletedBy;
  }

  get id(): number {
    return this._id;
  }

  get email(): string | null {
    return this._email;
  }

  get isActive(): boolean {
    return this._isActive;
  }

  get createdAt(): string | null {
    return this._createdAt;
  }

  get createdBy(): number | null {
    return this._createdBy;
  }

  get updatedAt(): string | null {
    return this._updatedAt;
  }

  get updatedBy(): number | null {
    return this._updatedBy;
  }

  get deletedAt(): string | null {
    return this._deletedAt;
  }

  get deletedBy(): number | null {
    return this._deletedBy;
  }

  static from(props: IBrandPurchaserLink): BrandPurchaserLink {
    return new BrandPurchaserLink(props);
  }
}
